import { indexOf, filter, castArray, cloneDeep } from 'lodash';
import React from 'react';

// import default view
import { dateTimeSelection as DateTimeSelectionView } from './dateTimeSelection.view';

/**
 * @type {function}
 * @desc A Higher-Order-Component to enhance functionality of `Component`
 * @param {object} Component - A React component
 * @example
 * import { dateTimeSelection, DateTimeSelection } from 'modules/dateTimeSelection';
 *
 * // create a component
 * const ComponentWithHOC = dateTimeSelection( CustomView );
 */
export  class DateTimeSelection extends React.Component {
    constructor( props ) {
        super( props );

        this.state = this.composeDataFromProps( this.props );

        //bind
        this.handleFormSubmit = this.handleFormSubmit.bind( this );
        this.handleClearSelection = this.handleClearSelection.bind( this );
    }

    composeDataFromProps( props ) {
        log.debug( 'DateTimeSelection.composeDataFromProps()' );

        const { subFields, config } = props;

        const fields = filter( subFields, field => {
            return -1 !== indexOf( config.subFields, field.name );
        } );

        return {
            fields
        };
    
    }
    
    handleFormSubmit( values ) {
        log.debug( 'DateTimeSelection.handleFormSubmit()' );

        this.props.onChange( {
            name: this.props.name,
            value: [ ...this.props.value, ...castArray( values ) ]
        } );
    }

    handleClearSelection( index ) {
        log.debug( 'DateTimeSelection.handleClearSelection()' );

        const newlist = filter( cloneDeep( this.props.value ), ( val, _index ) => {
            return _index !== index;
        } );

        this.props.onChange( {
            name: this.props.name,
            value: newlist
        } );
    }

    render() {
        return (
            <DateTimeSelectionView
                { ...this.props }
                { ...this.state }
                onFormSubmit={ this.handleFormSubmit }
                clearSelection={ this.handleClearSelection }
            />
        );
    }
}

// set display name
DateTimeSelection.displayName = 'DateTimeSelection';

// default props
DateTimeSelection.defaultProps = {
    actions: [
        {
            name: 'add',
            title: {
                refId: 'displayTextAdd'
            }
        }
    ]
};

// prop types
DateTimeSelection.propTypes = {};


